import TimePeriods from "../components/Dashboard/ProductCategories/TimePeriod/TimePeriods";
import TimePeriodDetails from "../components/Dashboard/ProductCategories/TimePeriod/TimePeriodDetails";
import TimePeriod from "../components/Dashboard/ProductCategories/TimePeriod/TimePeriod";

const timePeriodRoutes = [
  {
    path: "productCategories/timePeriods",
    component: TimePeriods,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "TimePeriods",
  },
  {
    path: "productCategories/timePeriod",
    component: TimePeriod,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "TimePeriod",
  },

  {
    path: "productCategories/timePeriod/:id",
    component: TimePeriodDetails,
    meta: {
      required: true,
      roles: ["PanelUser"],
    },
    name: "MilkTypeDetails",
  },
]

export default timePeriodRoutes;